import { render } from "./new_stack_p1_E.vue?vue&type=template&id=50e933d2&scoped=true"
import script from "./new_stack_p1_E.vue?vue&type=script&lang=js"
export * from "./new_stack_p1_E.vue?vue&type=script&lang=js"

import "./new_stack_p1_E.vue?vue&type=style&index=0&id=50e933d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e933d2"]])

export default __exports__